import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/RecoilAtom";

const ClaimCheck = () => {
    const web3 = useWeb3();
    const smartAccount = useRecoilValue(userSmartAccount)
    
    const ClaimCheckHook = useCallback(
        async (address) => {
            if (!web3.utils.isAddress(address)) {
                return; 
            }
            const contract = getTrade(address, web3);
            if (!contract) {
                console.error("Failed to get contract instance");
                return; 
            }
            try {
                const claimed = await contract.methods.claimed(smartAccount).call();
                return claimed;
            } catch (error) {
                console.error("Error fetching claimed status:", error.message || error);
                throw error;
            }
        },
        [web3, smartAccount]
    );
    
    return { ClaimCheckHook };
};

export default ClaimCheck;
